import React from "react";
import "./Policies.css";

const policies = [
  {
    title: "Interest Rate Policy",
    description:
      "Transparent interest rates, charges, and pricing framework for our lending products.",
    pdf: "/Interest Rate Policy.pdf",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
        <path d="M12 7v10M9.5 9.5c0-1.1 1.12-2 2.5-2s2.5.9 2.5 2-1.12 2-2.5 2-1.38 2-2.5 2.5-2.5 2.5.9 2.5 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Grievance Redressal Policy",
    description:
      "How to raise complaints and our commitment to fair, timely resolution.",
    pdf: "/Grievance Redressal Policy.pdf",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 8a7 7 0 0 1 14 0v5a3 3 0 0 1-3 3h-1.5l-2.2 2.2a1 1 0 0 1-1.7-.7V16H8a3 3 0 0 1-3-3V8Z" stroke="currentColor" strokeWidth="2" />
        <circle cx="9" cy="11" r="1" fill="currentColor" />
        <circle cx="12" cy="11" r="1" fill="currentColor" />
        <circle cx="15" cy="11" r="1" fill="currentColor" />
      </svg>
    ),
  },
  {
    title: "Fair Practice Code",
    description:
      "Ethical standards and fair treatment principles for all our customers.",
    pdf: "/Fair Practices Code.pdf",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3l7 3v6c0 4.5-3.2 7.8-7 9-3.8-1.2-7-4.5-7-9V6l7-3Z" stroke="currentColor" strokeWidth="2" />
        <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

const Policies = () => (
  <div className="policies-page">
    <section className="policies-hero">
      <p className="policies-eyebrow">RBI COMPLIANCE</p>
      <h1>Regulatory Policies</h1>
      <p className="policies-hero-subtitle">
        Click any policy below to open the document in a new tab.
      </p>
    </section>

    <section className="policies-cards-section">
      <div className="policies-cards-grid">
        {policies.map((policy) => (
          <article key={policy.title} className="policy-card">
            <div className="policy-card-icon">{policy.icon}</div>
            <h2>{policy.title}</h2>
            <p>{policy.description}</p>
            <a
              href={encodeURI(policy.pdf)}
              target="_blank"
              rel="noopener noreferrer"
              className="policy-card-link"
            >
              Open PDF
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M14 5h5v5M10 14L19 5M19 14v5H5V5h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </article>
        ))}
      </div>
    </section>
  </div>
);

export default Policies;
